import React, { FC, useEffect } from 'react';
import useTitleBarSelect from '../../../../hooks/useTitleBarSelect';
import LasdabChart from './chart';
import LasdabTable from './table';
import { useDispatch } from 'react-redux';
import { Select } from '../../../../types/redux/pages/PagesStore';
import {
  addAdditionalTitleBarComponents,
  removeTitleBarComponent,
} from '../../../../redux/pages/actions';
import {
  APPEND_NEW_SELECT_TO_TITLEBAR,
  REMOVE_SELECT_FROM_TITLEBAR,
} from '../../../../types/redux/pages/pageTypes';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { useLasdabPageModel } from '../../../../api/rs-hg/liquidity/hooks/queries';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';

export const scenarioMapGeneral: {
  [key: string]: string;
} = {
  standard: 'Standard',
  stressed: 'Stressed',
  superStressed: 'Super Stressed',
};

const LiquidityAdjustedSettlementDateAchievableBalancePage: FC<
  FundInfoComponentProps
> = ({ fundId, fundName, positionDate }) => {
  const dispatch = useDispatch();

  // Add the select components to the title bar
  useEffect(() => {
    const selectsToAdd: Select[] = [
      {
        titleBarTitle: 'Stress Level: ',
        titleBarKey: 'stressLevel',
        values: [
          {
            label: 'Standard',
            value: 'standard',
          },
          {
            label: 'Stressed',
            value: 'stressed',
          },
          {
            label: 'Super Stressed',
            value: 'superStressed',
          },
        ],
        displayOnOverviewPage: true,
        aValueIsAlwaysSelected: true,
        currentValue: 'standard',
      },
    ];

    dispatch(
      addAdditionalTitleBarComponents(
        selectsToAdd,
        APPEND_NEW_SELECT_TO_TITLEBAR,
      ),
    );

    return () => {
      dispatch(
        removeTitleBarComponent('stressLevel', REMOVE_SELECT_FROM_TITLEBAR),
      );
    };
  }, []);

  const chosenStressLevel = useTitleBarSelect('stressLevel') || 'standard';

  const lasdabQuery = useLasdabPageModel(fundId, positionDate);

  return (
    <QueryBoundary
      isLoading={lasdabQuery.isLoading}
      isFetching={lasdabQuery.isFetching}
      isError={lasdabQuery.isError}
      error={lasdabQuery.error}
      data={lasdabQuery.data?.data}
      loadingMessages={['Loading LASDAB data...']}
      noDataMessage="No Data Available."
    >
      {(resolvedData) => (
        <>
          <LasdabTable
            fundName={fundName}
            data={resolvedData}
            isFetching={lasdabQuery.isFetching}
            stressLevel={chosenStressLevel}
          />
          <LasdabChart
            data={resolvedData}
            stressLevel={chosenStressLevel}
          />
        </>
      )}
    </QueryBoundary>
  );
};

export default LiquidityAdjustedSettlementDateAchievableBalancePage;
